import { useEffect, useState } from "react";
import consultPlanService from "./ConsultPlanService";
import { Notify } from "../Notify";
import { useTranslation } from "react-i18next";
import ConsultPlan from "./ConsultPlan";

export default function useConsultPlans(organizationId: string | undefined) {
  const { t } = useTranslation();

  const [consultPlans, setConsultPlans] = useState<Array<ConsultPlan>>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    async function refresh() {
      if (organizationId) {
        try {
          const consultPlans = await consultPlanService.getConsultPlans(organizationId);
          setConsultPlans(consultPlans);
          setLoading(false);
        } catch (e) {
          console.log("useConsultPlans", e);
          Notify.error(`${t("common.unexpected-error")}`);
        }
      }
    }

    refresh();
  }, [organizationId]);

  return {
    loading,
    consultPlans,
  };
}
